// components/MatchThreadChannelSelect.jsx
import ChantSelect from "../../../../CommonComponents/ChantSelect/ChantSelect";
import { useChannels } from "../../../../hooks/useChannels";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import useUserStore, { selectUserDetails } from "../../../../store/user/user";

const CHAT_STREAM_OPTION = { value: null, label: "Chat Stream (default)" };

export function ChatStreamSelector({ value, onChange }) {
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const userDetails = useUserStore(selectUserDetails);
  const { matchThreadChannels, loading } = useChannels(groupData, userDetails);

  const options = [CHAT_STREAM_OPTION, ...matchThreadChannels];

  if (matchThreadChannels?.length === 0 && !loading) {
    return null;
  }

  return (
    <ChantSelect
      style={{ minWidth: "300px", maxWidth: "400px" }}
      label={
        <>
          <span>
            Set group Match Thread destination{" "}
            <span style={{ color: "#666666" }}>
              (Selecting a Channel will hide the default thread in Chat Stream)
            </span>
          </span>
        </>
      }
      options={options}
      value={loading ? null : value}
      onChange={onChange}
      loading={loading}
      disabled={loading}
    />
  );
}
